import React from "react";
import ReactDOM from "react-dom/client";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";

import "./index.css";
import "./Assets/Css/Global.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "dayjs/locale/fr";

// import enUS from "antd/es/locale/en_US"; // Import the English (United States) locale for Ant Design
// import { ConfigProvider } from "antd";
// import moment from "moment";

import "bootstrap/dist/css/bootstrap.min.css";
import { HelmetProvider } from "react-helmet-async";

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

// dayjs.locale("fr");
// moment.locale("en");
//  <ConfigProvider locale={enUS}>
//    <App />
//  </ConfigProvider>;
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
